import { History } from 'lucide-react'
import { SectionCard, EmptyState } from '@/components/ui'
import { Timeline } from '@/components/timeline/Timeline'
import type { AccountDerived } from '../lib'

export default function HistoryTab({ d }: { d: AccountDerived }) {
  if (!d.activities.length) {
    return (
      <SectionCard pad>
        <EmptyState icon={<History size={36} />} title="No activity logged yet" hint="Notes, emails, calls, meetings, and milestones across this account, its tracks, and its properties will appear here, newest first." />
      </SectionCard>
    )
  }

  return (
    <SectionCard eyebrow="Activity" title={<>Relationship <b>History</b></>} right={<span className="aw-count-pill">{d.activities.length}</span>}>
      <Timeline activities={d.activities} />
    </SectionCard>
  )
}
